/**
 * pwaInstall — مدیریت «نصب به‌عنوان اپلیکیشن».
 *
 * رویداد beforeinstallprompt را می‌گیرد و نگه می‌دارد تا کاربر خودش دکمه‌ی نصب را بزند.
 * روی iOS/Safari این رویداد وجود ندارد؛ در آن حالت isIosSafari() راهنمای دستی
 * «افزودن به صفحه‌ی اصلی» را نشان می‌دهد.
 */

import { reactive } from "vue";

export const pwaState = reactive({
    canInstall: false, // beforeinstallprompt دریافت شده و هنوز نصب نشده
    installed: false, // در حالت standalone اجرا می‌شود یا appinstalled رخ داده
});

let deferredPrompt = null;
const DISMISS_KEY = "pwa_install_dismissed";

function isStandalone() {
    if (typeof window === "undefined") return false;
    return (
        (window.matchMedia &&
            window.matchMedia("(display-mode: standalone)").matches) ||
        window.navigator.standalone === true
    );
}

export function isIosSafari() {
    if (typeof window === "undefined") return false;
    const ua = window.navigator.userAgent || "";
    const iOS = /iPad|iPhone|iPod/.test(ua);
    const webkit = /WebKit/.test(ua);
    return iOS && webkit && !/CriOS|FxiOS|EdgiOS|OPiOS/.test(ua);
}

export function isBannerDismissed() {
    try {
        return localStorage.getItem(DISMISS_KEY) === "1";
    } catch (e) {
        return false;
    }
}

export function dismissBanner() {
    try {
        localStorage.setItem(DISMISS_KEY, "1");
    } catch (e) {
        /* noop */
    }
}

export function initPwaInstall() {
    if (typeof window === "undefined") return;

    if (isStandalone()) {
        pwaState.installed = true;
        return;
    }

    window.addEventListener("beforeinstallprompt", (e) => {
        e.preventDefault();
        deferredPrompt = e;
        pwaState.canInstall = true;
    });

    window.addEventListener("appinstalled", () => {
        pwaState.installed = true;
        pwaState.canInstall = false;
        deferredPrompt = null;
        try {
            localStorage.removeItem(DISMISS_KEY);
        } catch (e) {
            /* noop */
        }
    });
}

/**
 * نمایش دیالوگ نصب مرورگر.
 * @returns {Promise<'accepted'|'dismissed'|'unavailable'>}
 */
export async function promptInstall() {
    if (!deferredPrompt) return "unavailable";
    try {
        deferredPrompt.prompt();
        const choice = await deferredPrompt.userChoice;
        deferredPrompt = null;
        pwaState.canInstall = false;
        return (choice && choice.outcome) || "dismissed";
    } catch (e) {
        deferredPrompt = null;
        pwaState.canInstall = false;
        return "dismissed";
    }
}

export default {
    pwaState,
    initPwaInstall,
    promptInstall,
    isIosSafari,
    isBannerDismissed,
    dismissBanner,
};
